/**
 * A well's `group` marks it as a subordinate well — either a horizontal leg or a
 * SAGD injection well. Subordinate wells inherit their parent's colour. Single
 * source of truth for that check across the 3D viewer.
 */
export function isSubordinateWell(group: Maybe<string>): boolean {
  return group === "leg" || group === "inj";
}

/** Only injectors draw dashed in 3D; legs are solid (EVA-201). */
export function isDashedWell(group: Maybe<string>): boolean {
  return group === "inj";
}
